import { NoDataTile, ScrollablePane, Stack } from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { SoftwarePackageVersion } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useSoftwarePackageDeploymentRings } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { getDeploymentRingResultantVersions } from "./deploymentRingResultantVersion.utils";
import { SoftwarePackageDeploymentRingsTable } from "./SoftwarePackageDeploymentRingsTable";

interface SoftwarePackageDeploymentRingsProps {
  softwarePackageId: string;
  softwarePackageVersions: SoftwarePackageVersion[];
}

export const SoftwarePackageDeploymentRings: React.FC<SoftwarePackageDeploymentRingsProps> = ({
  softwarePackageId,
  softwarePackageVersions
}) => {
  const deploymentRingsQuery = useSoftwarePackageDeploymentRings(
    softwarePackageId
  );

  return (
    <QueryStateIndicator
      {...deploymentRingsQuery}
      loadingTitle="Loading deployment rings, please wait..."
      noDataText="This software package is not present in any deployment ring."
    >
      {deploymentRings => {
        const items = getDeploymentRingResultantVersions(
          deploymentRings,
          softwarePackageVersions
        );

        if (items.length === 0) {
          return (
            <NoDataTile
              styles={{ root: { flexGrow: 1 } }}
              textProps={{
                text:
                  "This software package is not present in any deployment ring."
              }}
              linkProps={{}}
              showBoxShadow={false}
            />
          );
        }

        return (
          <Stack.Item
            grow
            styles={{ root: { position: "relative", minHeight: 0 } }}
          >
            <ScrollablePane>
              <SoftwarePackageDeploymentRingsTable items={items} />
            </ScrollablePane>
          </Stack.Item>
        );
      }}
    </QueryStateIndicator>
  );
};
